module.exports = __webpack_public_path__ + "static/media/logo_shoppaworld-invert.097a0574.svg";